export enum DialogErrorCode {
    NotFound = 12002,
    HttpsRequired = 12003,
    Closed = 12006
}